import { useState } from "react";

const faqItems = [
  {
    q: "What vehicle types do you store indoors?",
    a: "We store automobiles, classic cars, motorcycles, RVs, motorhomes, boats, trucks, and specialty equipment — all indoors in our fully-alarmed Bay Area facilities. Contact us to confirm space availability for your specific vehicle.",
  },
  {
    q: "Do you offer long-term storage rates?",
    a: "Yes. We offer the best rates for long-term storage. Pricing varies by vehicle size, type, and duration. Call (415) 453-9180 or inquire online for current availability and rate information.",
  },
  {
    q: "Is your storage facility climate controlled?",
    a: "Our indoor facilities provide a stable, weather-protected environment. Keeping vehicles indoors prevents damage from Bay Area humidity, temperature fluctuations, UV exposure, and moisture — critical for preserving classic and collector vehicles.",
  },
  {
    q: "Can you store oversized vehicles like RVs or trucks?",
    a: "Yes, both our San Rafael and Point Richmond facilities can accommodate larger vehicles including RVs, motorhomes, trucks, and specialty equipment. Call us first to confirm available space for your specific vehicle dimensions.",
  },
  {
    q: "Do you offer motorcycle transport to your storage facility?",
    a: "Yes. Jim Long offers motorcycle road service and transport for Bay Area riders. If your motorcycle needs transport to our facility, call (415) 846-4281 and we'll coordinate pickup and secure storage.",
  },
  {
    q: "What is the minimum storage duration?",
    a: "Storage fees vary by the length of stay and vehicle size. We accommodate both short-term and long-term storage — with the best rates offered for longer commitments. Contact us to discuss options that fit your needs.",
  },
  {
    q: "How do I drop off my vehicle for storage?",
    a: "Storage drop-off is by appointment only. Call us first at (415) 453-9180 so we can confirm availability and schedule your arrival. Please don't show up without calling — we want to make sure we're ready for your visit.",
  },
];

export default function ServicesFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section
      id="faq"
      className="bg-[#F8F8F8] py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            Storage Services FAQ
          </p>
          <h2 className="font-serif text-charcoal text-4xl lg:text-5xl font-bold mb-4">
            Common Storage Questions
          </h2>
          <p className="font-sans text-[#777] text-base">
            Specific answers about our storage services, vehicle types, and how we operate.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden"
              style={{ borderLeft: openIdx === idx ? "2px solid #D4AF37" : "2px solid transparent" }}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <h3
                  className="font-sans text-charcoal text-base font-semibold pr-4 leading-snug"
                  itemProp="name"
                >
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`${
                      openIdx === idx ? "ri-subtract-line text-gold" : "ri-add-line text-gold"
                    } text-lg transition-all duration-200`}
                  ></i>
                </div>
              </button>
              {openIdx === idx && (
                <div
                  className="px-6 pb-5"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p
                    className="font-sans text-[#666] text-sm leading-relaxed"
                    itemProp="text"
                  >
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
